import AddFavorite from './AddFavorite';

export default AddFavorite;
